"use client";
import WebContainer from "@/components/basic-components/WebContainer";
import { getContentPageSlug } from "@/utils/items/navigation";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useFaqSite } from "./FaqSiteContext";

// `id="footer"` is what hides it in the app's webview and in an iframe (?plain=true, ?iframe=true).
export const FaqFooter: FunctionComponent = () => {
	const { t } = useTranslation(["faq"]);
	const { language, linkBase } = useFaqSite();
	const links = [
		{ label: t("faq:footer.termsOfService"), slug: getContentPageSlug("termsOfService", language) },
		{ label: t("faq:footer.privacyPolicy"), slug: getContentPageSlug("privacyPolicy", language) },
		{ label: t("faq:footer.contact"), slug: getContentPageSlug("contact", language) },
	];

	return (
		<footer id="footer" className="border-bg-primary-border mt-spacing-lg border-t">
			<WebContainer className="gap-spacing-sm py-spacing-md text-footnote text-text-muted flex-col md:flex-row md:justify-between">
				<span>{t("faq:footer.tagline")}</span>
				<ul className="gap-x-spacing-md gap-y-spacing-xs flex flex-wrap">
					{links.map((link) => (
						<li key={link.label}>
							<a href={`${linkBase.marketplaceOrigin}/${language}/info/${link.slug}`} className="hover:underline">
								{link.label}
							</a>
						</li>
					))}
				</ul>
			</WebContainer>
		</footer>
	);
};
